import { render, staticRenderFns } from "./pdlLoan.vue?vue&type=template&id=077fd942"
import script from "./pdlLoan.vue?vue&type=script&lang=js"
export * from "./pdlLoan.vue?vue&type=script&lang=js"
import style0 from "./pdlLoan.vue?vue&type=style&index=0&id=077fd942&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports